import classNames from 'classnames';
import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ValidName } from '@javascript/lib/regularExpressions';

const formSchema = object().shape({
  firstName: string()
    .matches(ValidName, 'Please enter a valid name')
    .required('Please enter your first name'),
  lastName: string()
    .matches(ValidName, 'Please enter a valid name')
    .required('Please enter your last name'),
});

interface FormInput {
  firstName: string;
  lastName: string;
}
interface NameViewProps {
  customerDetails: { first_name: string; last_name: string };
  nextView: () => void;
  updateCustomerDetails: (details: {
    first_name: string;
    last_name: string;
  }) => void;
}

const NameView = ({
  customerDetails,
  nextView,
  updateCustomerDetails,
}: NameViewProps): JSX.Element => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmit: SubmitHandler<FormInput> = (data) => {
    updateCustomerDetails({
      first_name: data.firstName,
      last_name: data.lastName,
    });
    nextView();
  };

  return (
    <div className="db-modal__content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <section className="db-section ac-animation--fade-in-from-right">
          <h2 className="db-question ch-mb--3">
            Let&apos;s start with your name
          </h2>
          <div
            className={classNames(
              'ch-form__group',
              errors.firstName && 'ch-form__group--error',
            )}
          >
            <label className="ch-label" htmlFor="firstName">
              First name
            </label>
            <p className="ch-form__control-hint">As on your driving licence</p>
            <span className="ch-form__control-validation">
              {errors.firstName?.message}
            </span>
            <input
              className="ch-form__control ch-mb--3"
              defaultValue={customerDetails.first_name}
              id="firstName"
              type="text"
              {...register('firstName')}
            />
          </div>
          <div
            className={classNames(
              'ch-form__group',
              errors.lastName && 'ch-form__group--error',
            )}
          >
            <label className="ch-label" htmlFor="lastName">
              Last name
            </label>
            <p className="ch-form__control-hint">As on your driving licence</p>
            <span className="ch-form__control-validation">
              {errors.lastName?.message}
            </span>
            <input
              className="ch-form__control ch-mb--3"
              defaultValue={customerDetails.last_name}
              id="lastName"
              type="text"
              {...register('lastName')}
            />
          </div>
          <p className="ch-fs--1 ch-color--grey-6">
            By making a reservation you are agreeing to our
            <br />
            <a href="/terms-of-use">Terms of Use</a> and{' '}
            <a href="/cookies">Privacy Policy</a>.
          </p>
        </section>
        <section className="db-section db-section--cta">
          <button className="ch-btn ch-btn--block ch-btn--cta" type="submit">
            Next: Your contact details
          </button>
        </section>
      </form>
    </div>
  );
};

export default NameView;
